import LazyLoad from 'vanilla-lazyload';
import common from './components/c-common';
import cAppeared from './components/c-appeared';
import cOutline from './components/c-outline';
import preloader from './components/c-preloader';
import cookieConsentDelay from './components/c-cookie-consent-delay';
import customSelect from './components/c-custom-select';
import header from './blocks/header';
import menu from './blocks/menu';
import navigationMedia from './blocks/navigation-media';
import singleMenus from './blocks/single-menus';

common();
cAppeared();
cOutline();
preloader();
cookieConsentDelay();
customSelect();
header();
menu();
navigationMedia();
singleMenus();

document.addEventListener('preloader:done', (event) => {
  const lazy = new LazyLoad({
    elements_selector: '.lazy',
  });
});
